import { Injectable, NgZone, signal } from '@angular/core';
import { Router } from '@angular/router';

import { resolveListRouteFromCurrentUrl } from '../utils/detail-resource-routes.util';

@Injectable({ providedIn: 'root' })
export class ResourceNotFoundService {
  private readonly _visible = signal(false);
  private listRoute: string | null = null;
  private isHandling = false;

  readonly visible = this._visible.asReadonly();

  constructor(
    private readonly router: Router,
    private readonly ngZone: NgZone
  ) {}

  handle(listRoute?: string | null): void {
    if (this.isHandling) {
      return;
    }

    const route = listRoute ?? resolveListRouteFromCurrentUrl(this.router);
    if (!route) {
      return;
    }

    this.ngZone.run(() => {
      this.isHandling = true;
      this.listRoute = route;
      this._visible.set(true);
    });
  }

  getListRoute(): string | null {
    return this.listRoute;
  }

  reset(): void {
    this._visible.set(false);
    this.listRoute = null;
    this.isHandling = false;
  }

  closeAndRedirect(): void {
    this.ngZone.run(() => {
      const route = this.listRoute ?? resolveListRouteFromCurrentUrl(this.router);
      this.reset();

      if (!route) {
        return;
      }

      void this.router.navigateByUrl(`/${route}`, { replaceUrl: true });
    });
  }
}
